/** Single source of truth for the production site origin used in canonical, og:url and JSON-LD. */
export const SITE_ORIGIN = "https://agapeco.net";
